import { memo, FC } from 'react'

import { MapCoreProps } from './types'
import MapCoreManagerProvider from './contexts/MapCoreManager/Provider'
import Component from './Component'

const MapCore: FC<MapCoreProps> = ({ children, ...props }: any) => {
  return (
    <MapCoreManagerProvider {...props}>
      <>
        <Component />
        {children}
      </>
    </MapCoreManagerProvider>
  )
}

export default memo(MapCore)
